import { render, staticRenderFns } from "./AdditionalResourceList.vue?vue&type=template&id=b3082970"
import script from "./AdditionalResourceList.vue?vue&type=script&lang=ts"
export * from "./AdditionalResourceList.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalResourceList.vue?vue&type=style&index=0&id=b3082970&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports